export const DEVELOPMENT_ENV = "dev";
export const STAGING_ENV = "staging";
